import {Navigate, useLocation} from "react-router-dom";
import {GlobalContext} from "../../util/state/GlobalContextProvider";
import {useContext, useEffect, useState} from "react";
import {useUserActions} from "./service/user.actions";
import {getCookie} from "../../util/state/commonFunctions";

const AuthMain = ({children}: { children: JSX.Element }) => {
    const {globalData} = useContext(GlobalContext);
    const location = useLocation();
    const userActions = useUserActions();
    const [render, setRender] = useState<any>(null);
    const username = getCookie("username") || "";

    useEffect(() => {
        if (!globalData.user) {
            userActions.getUser(username).finally(() => {
                if (!globalData.user) {
                    setRender(<Navigate to="/login" state={{from: location}}/>);
                } else {
                    setRender(children);
                }
            });
        } else {
            setRender(children);
        }
    }, []);

    return render;
}

export default AuthMain;
